<div class="row dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div class="col-11 left">
        <h4>{{ 'menu.add-news' | translate }}</h4>
    </div>
    <div class="col-1 right">
        <button (click)="dialogRef.close()">
            <i class="a-icon a-icon--close"></i>
        </button>
    </div>
</div>
<div class="row">
    <mat-form-field appearance="fill" class="col-4">
        <mat-label>{{ 'admin.edit-news.critical' | translate }}</mat-label>
        <mat-select
            [ngModel]="draftItem.critical"
            (ngModelChange)="onDraftItemCriticalChange($event)"
            placeholder="{{ 'admin.edit-news.critical' | translate }}"
        >
            <mat-option [value]="true">{{ 'admin.edit-news.critical' | translate }}</mat-option>
            <mat-option [value]="false">{{ 'admin.edit-news.not-critical' | translate }}</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" class="col-4">
        <mat-label>{{ 'admin.edit-news.target-group' | translate }}</mat-label>
        <mat-select
            (selectionChange)="draftItem.targetGroup = null; draftItem.targetTeam = null"
            [ngModel]="draftItem.target"
            (ngModelChange)="onDraftItemTargetChange($event)"
            [disabled]="!appUserService.isAdmin()"
            placeholder="{{ 'admin.edit-news.target-group' | translate }}"
        >
            <mat-option value="All">{{ 'shared.miscellaneous.all' | translate }}</mat-option>
            <mat-option value="Group">{{ 'shared.miscellaneous.group' | translate }}</mat-option>
            <mat-option value="Team">{{ 'shared.miscellaneous.team' | translate }}</mat-option>
        </mat-select>
    </mat-form-field>
    @if (draftItem.target === 'Group') {
        <mat-form-field appearance="fill" class="col-4">
            <mat-label>{{ 'shared.miscellaneous.group' | translate }}</mat-label>
            <mat-select
                [ngModel]="draftItem.targetGroup"
                (ngModelChange)="onDraftItemTargetGroupChange($event)"
                [compareWith]="compareLookups"
                [disabled]="!appUserService.isAdmin()"
                placeholder="{{ 'shared.miscellaneous.group' | translate }}"
            >
                @for (item of portfolios; track item) {
                    <mat-option [value]="item">{{ item.title }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    }
    @if (draftItem.target === 'Team') {
        <mat-form-field appearance="fill" class="col-4">
            <mat-label>{{ 'shared.miscellaneous.team' | translate }}</mat-label>
            <mat-select
                [ngModel]="draftItem.targetTeam"
                (ngModelChange)="onDraftItemTargetTeamChange($event)"
                [compareWith]="compareLookups"
                [disabled]="!appUserService.isAdmin()"
                placeholder="{{ 'shared.miscellaneous.team' | translate }}"
            >
                @for (item of businessAreas; track item) {
                    <mat-option [value]="item">{{ item.longName ? item.longName : item.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    }
</div>
<div class="row">
    <mat-form-field appearance="fill" class="col-4">
        <mat-label>{{ 'admin.edit-news.priority' | translate }}</mat-label>
        <mat-select
            [ngModel]="draftItem.priority"
            (ngModelChange)="onDraftItemPriorityChange($event)"
            placeholder="{{ 'admin.edit-news.priority' | translate }}"
        >
            <mat-option [value]="0">{{ 'admin.edit-news.priority' | translate }} 0</mat-option>
            <mat-option [value]="1">{{ 'admin.edit-news.priority' | translate }} 1</mat-option>
            <mat-option [value]="2">{{ 'admin.edit-news.priority' | translate }} 2</mat-option>
            <mat-option [value]="3">{{ 'admin.edit-news.priority' | translate }} 3</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" class="col-4">
        <mat-label>{{ 'shared.properties.valid-to' | translate }}</mat-label>
        <input
            [ngModel]="draftItem.validTo"
            (ngModelChange)="onDraftItemValidToChange($event)"
            [matDatepicker]="date"
            matInput
            placeholder="{{ 'shared.properties.valid-to' | translate }}"
        />
        <mat-datepicker-toggle [for]="date" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #date></mat-datepicker>
    </mat-form-field>
</div>
<div class="row">
    <div class="col-12 mb-2">
        <mat-card class="news-tile" [ngClass]="{ critical: draftItem.critical, info: !draftItem.critical }">
            <mat-card-content>
                <table>
                    <tr>
                        <td id="news-img">
                            <div>
                                <mat-icon>{{ draftItem.critical ? 'flash_on' : 'info' }}</mat-icon>
                            </div>
                        </td>

                        <td class="row">
                            <mat-form-field appearance="fill" class="col-6">
                                <mat-label>{{ 'admin.edit-news.news-title' | translate }}</mat-label>
                                <input
                                    matInput
                                    [ngModel]="draftItem.title"
                                    (ngModelChange)="onDraftItemTitleChange($event)"
                                />
                            </mat-form-field>
                            <mat-form-field appearance="fill" class="col-12">
                                <mat-label>{{ 'admin.edit-news.news-content' | translate }}</mat-label>
                                <textarea
                                    cdkTextareaAutosize
                                    #autosize="cdkTextareaAutosize"
                                    cdkAutosizeMinRows="2"
                                    cdkAutosizeMaxRows="10"
                                    [ngModel]="draftItem.content"
                                    (ngModelChange)="onDraftItemContentChange($event)"
                                    matInput
                                ></textarea>
                            </mat-form-field>
                        </td>
                    </tr>
                </table>
            </mat-card-content>
        </mat-card>
    </div>
</div>
<div class="row">
    <div class="col-12 mb-2">
        <div class="d-flex justify-content-end gap-10">
            <ceres-button (click)="save()" [disabled]="checkDisability()" icon="check-mark" type="button">{{
                'shared.buttons.save' | translate
            }}</ceres-button>
        </div>
    </div>
</div>
